export interface DivisionNode {
    division: {
        id: number;
        name: string;
    };
    nodes: DivisionNode[];
}

/**
 * 부서 트리에서 특정 부서 ID의 전체 경로를 구합니다.
 * @param divisionId 찾을 부서 ID
 * @param divisionTree 부서 트리 데이터
 * @param path 현재까지의 경로 (재귀 호출용)
 * @returns 부서의 전체 경로 배열
 */
export const getDivisionPath = (divisionId: number, divisionTree: DivisionNode[], path: string[] = []): string[] => {
    for (const node of divisionTree) {
        const currentPath = [...path, node.division.name];

        if (node.division.id === divisionId) {
            return currentPath;
        }

        if (node.nodes && node.nodes.length > 0) {
            const result = getDivisionPath(divisionId, node.nodes, currentPath);
            if (result.length > 0) {
                return result;
            }
        }
    }
    return [];
};

/**
 * 부서 트리에서 특정 부서 ID의 전체 경로를 문자열로 반환합니다.
 * @param divisionId 찾을 부서 ID
 * @param divisionTree 부서 트리 데이터
 * @param separator 경로 구분자 (기본값: ' / ')
 * @returns 부서의 전체 경로 문자열
 */
export const getDivisionFullPath = (divisionId: number, divisionTree: DivisionNode[], separator: string = ' / '): string => {
    if (!divisionTree || !Array.isArray(divisionTree)) return '';
    const pathArray = getDivisionPath(divisionId, divisionTree);
    return pathArray.join(separator);
};
